module.exports = __webpack_public_path__ + "img/block_cert_full.52c3b4fb.png";